import React__default from 'react';
import PropTypes from 'prop-types';
import Title from './Title.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import './_rollupPluginBabelHelpers-e71b1aad.js';
import 'moment';

function EmptySectionMessage(props) {
  var className = props.className,
    title = props.title,
    content = props.content,
    children = props.children,
    titleSize = props.titleSize;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-empty-section-message ".concat(className)
  }, title ? /*#__PURE__*/React__default.createElement(Title, {
    content: title,
    size: titleSize,
    className: "bf-empty-section-message-title"
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-empty-section-message-content"
  }, content || children));
}
EmptySectionMessage.defaultProps = {
  className: '',
  title: '',
  titleSize: 'normal',
  content: '',
  children: ''
};
EmptySectionMessage.propTypes = {
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  EmptySectionMessage title
   */
  title: nodeOrStringProp,
  /**
  EmptySectionMessage title size
   */
  titleSize: PropTypes.string,
  /**
  EmptySectionMessage content
   */
  content: nodeOrStringProp,
  /**
  EmptySectionMessage content
   */
  children: nodeOrStringProp
};

export default EmptySectionMessage;
//# sourceMappingURL=EmptySectionMessage.js.map
